import { render } from "./userinfo.vue?vue&type=template&id=2878aaf6&scoped=true"
import script from "./userinfo.vue?vue&type=script&lang=js"
export * from "./userinfo.vue?vue&type=script&lang=js"

import "./userinfo.vue?vue&type=style&index=0&id=2878aaf6&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"
import "./userinfo.vue?vue&type=style&index=1&id=2878aaf6&lang=css"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2878aaf6"]])

export default __exports__